export default function pmIdToAvatar(
  id: string,
  context: { currentHgCdn: () => string },
  avatarVersion: number = Date.now()
): string {
  const environment = context.currentHgCdn();
  const host = !environment ? "localhost:8095/img" : `${environment}`;
  return `//${host}/user/${id}.jpg?${avatarVersion}`; // timestamp for cache busting
}
